import { LogSeverity } from '../api'
import moment from 'moment'

export interface IDiagnosticsLogger {
  log: (message: string, severity?: LogSeverity) => void
  getLog: () => LogEntry[]
  clearLog: () => void
}

interface LogEntry {
  message: string
  timestamp: string
  severity: LogSeverity
}

class DiagnosticsLogger {
  private maxLogLength = 40

  public log = (message: string, severity?: LogSeverity) => {
    const formattedCallStack = new Error().stack
      ?.split('\n')
      .slice(0, 5)
      .join('\n')

    const logEntry: LogEntry = {
      severity: severity || LogSeverity.INFO,
      message: `${message}\n${formattedCallStack}`,
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss.SSS')
    }

    let newLog = this.getLog()

    if (newLog.length === this.maxLogLength) {
      newLog.shift()
    }

    newLog.push(logEntry)

    window.sessionStorage.setItem(`btqDiagnosticsLog`, JSON.stringify(newLog))
  }

  public getLog = () => {
    return JSON.parse(window.sessionStorage.getItem(`btqDiagnosticsLog`) || `[]`)
  }

  public clearLog = () => {
    window.sessionStorage.setItem(`btqDiagnosticsLog`, JSON.stringify([]))
  }
}

export const diagnosticsLogger = new DiagnosticsLogger()
